class ScriptingObjectProxy {
  /**
   * proxy type
   */
  __TYPE__ = "Proxy";
  /**
   * unique id of scripting object
   */
  id;
  /**
   * type of scripting object
   */
  objectType;
  /**
   * Creates a new instance of the Scripting Object Proxy
   * @param objectId unique id of scripting object
   * @param objectType type of scripting object
   */
  constructor(objectId, objectType) {
    this.id = objectId;
    this.objectType = objectType;
  }
}
const isScriptingObjectProxy = (value) => (
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  value?.constructor?.name === "Proxy" || // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  value?.constructor?.name === "ScriptingObjectProxy" || // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-underscore-dangle
  value?.__TYPE__ === "Proxy"
);
export {
  ScriptingObjectProxy,
  isScriptingObjectProxy
};
